import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default function SweetAlertModal({
  title,
  text,
  icon = "info", // Tipo de alerta: 'success', 'error', 'warning', 'info', 'question'
  confirmButtonText = "OK",
  cancelButtonText = "Cancelar",
  showCancelButton = false,
  onConfirm, 
  onCancel,
}) {
  const showModal = () => {
    MySwal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      cancelButtonText,
      showCancelButton,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
        onCancel();
      }
    });
  };

  return (
    <button onClick={showModal}>
      Mostrar Modal
    </button>
  );
}
